import React from "react";
import IconMore from "../../../assets/icon_more.svg";
import "./BrandRankingMore.css";
import { useAppInstallModal } from "../../../store/useAppInstallModal";
import { openAppAndAction } from "../../../util/util";

/**
 * 브랜드 랭킹 더보기 화면
 * @returns {React.JSX.Element}
 * @constructor
 */
const BrandRankingMore = () => {
  const { openModal } = useAppInstallModal();
  const handleOnClickPopup = () => {
    openAppAndAction(
      () => openModal("앱에서 더 많은\n브랜드를 발견해보세요!"),
      null,
      1000,
    );
  };

  return (
    <button
      type="button"
      onClick={handleOnClickPopup}
      className="BrandRankingMore"
    >
      <span>더보기</span>
      <img src={IconMore} alt="more" width={16} height={16} />
    </button>
  );
};

export default BrandRankingMore;
